<template>
  <div>
    <!-- <div class="my-3">
      <v-icon>fas fa-user</v-icon>
      <span class="mx-3">Gregorius Yoga</span>
    </div>-->
    <v-card color="basil">
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item">
          <v-card color="basil" flat>
            <BiodataDiri v-if="tab == 0" />
            <Alamat v-if="tab == 1" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import BiodataDiri from "../User/BiodataDiri";
import Alamat from "../User/Alamat";
export default {
  components: {
    BiodataDiri,
    Alamat
  },
  data() {
    return {
      tab: 0,
      items: ["Biodata Diri", "Daftar Alamat"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  }
};
</script>
<style>
/* Helper classes */
.basil {
  background-color: white !important;
}
.basil--text {
  color: #356859 !important;
}
</style>